import {browserHistory} from 'react-router';
import axios from 'axios';
import _ from 'lodash';

import APPCONFIG from 'constants/Config';

const AuthService = {

  getUserRole() {
    const state = JSON.parse( sessionStorage.getItem( 'smm' ) );
    const roles = state.user.roles;

    return {
      isOperator: roles && roles.indexOf( 'ROLE_OPERATOR' ) !== -1,
      isSupervisor: roles && roles.indexOf( 'ROLE_SUPERVISOR' ) !== -1,
      isAdmin: roles && roles.indexOf( 'ROLE_ADMIN' ) !== -1,
      isBroadcast: roles && roles.indexOf( 'ROLE_BROADCAST' ) !== -1
    }
  },

  /**
   * Intercept request
   */
  interceptorRequest() {
    axios.interceptors.request.use(
      function( config ) {
        config.timeout = 30000;
        if( config.url.match( 'v1/socialnetworks/[0-9]*/active' ) ) {
          config.timeout = 60000;
        }
        if( config.url.indexOf( 'ReporterServlet' ) === -1 )
          config.url = `${APPCONFIG.apiUrl}${config.url}`;

        const state = JSON.parse( sessionStorage.getItem( 'smm' ) );
        const token = _.get( state, 'user.access_token' );
        if( token && config.url.indexOf( 'ReporterServlet' ) === -1
          && config.url.indexOf( 'chat/register-channel' ) === -1
          && config.url.indexOf( 'chat/register-credential' ) === -1
          && config.url.indexOf( 'chat/message-client-file' ) === -1
          && config.url.indexOf( 'oauth/v2/token' ) === -1 ) {
          config.headers['Authorization'] = `Bearer ${token}`;
        }
        return config;
      },
      function( error ) {
        return Promise.reject( error );
      } );
  },

  /**
   * Intercept response
   */
  interceptResponse() {
    return axios.interceptors.response.use( response => {
      return response;
    }, error => {
      let response = error.response;

      if( response && response.status === 401 && window.location.href !== `${window.location.origin}/#/login`) {
        window.location.replace( `${window.location.origin}/#/login` );
      }
      else {
        let errors = _.get( response, 'data.detail', null );
        errors = _.get( response, 'data.message', errors );
        errors = _.get( response, 'data.error_description', errors );

        if( _.isObject( errors ) && !_.isArray( errors ) ) {
          errors = _.toArray( errors )
        }

        if( _.isArray( errors ) && !_.isString( errors[0] ) ) {
          errors = _
            .chain( errors )
            .map( error => {
              return _.flattenDeep( _.values( error ) )
            } )
            .flattenDeep()
            .value();
        }

        let status = response ? response.status : null;

        if( !errors ) {
          if( error.message === 'Network Error' ) {
            errors = 'Could not connect to the server (network error).';
          } else {
            errors = error.message;
          }
        }

        return { status, errors: _.isArray( errors ) ? errors.join( '<br/>' ) : errors }
      }
    } );
  },

  /**
   * Login user
   * @param {object}  credentials   user credentials
   */
  login( credentials ) {
    return axios
      .post( 'oauth/v2/token', {
        username: credentials.username,
        password: credentials.password,
        client_id: APPCONFIG.clientId,
        client_secret: APPCONFIG.clientSecret,
        grant_type: 'https://social-media.com/auth/web'
      } )
      .then( response => {
        return response
      } )
  },

  loginClient() {
    return axios
      .post( 'oauth/v2/token', {
        client_id: '4_1gwbn1aju3xccccwgow0sk4okcg8g4og8wg40kk0kc4ww88kkw',
        client_secret: '51hyz481pskcwksos8s0kkcokg0g8w8884cc8gwcwko4k4wwg0',
        grant_type: 'client_credentials'
      } )
      .then( response => {
        return response
      } )
  }
};

export default AuthService;



// WEBPACK FOOTER //
// ./services/AuthService.js